<template>
  <div class="didacticiel">

    <div class="grid-container content-page">
      <div class="grid-x grid-margin-x">
        <div class="small-12 medium-6 medium-offset-3 cell center">
          <title-page attrpage="Globulo Quest" baseline="">Inscription réussie</title-page>
        </div>
        <div class="small-12 medium-6 medium-offset-3 cell ">


          <div class="box-mascotte">
            <div class="bubble bottom txtleft">
              <carousel :perPage="1" paginationActiveColor="#de2128" navigationEnabled="true" paginationColor="#ccc" :paginationSize="15">
                <slide>
                  Félicitations ! Votre compte est bien créé. Vous avez dû recevoir un mail pour confirmer votre adresse.
                  <p>Vous pouvez désormais suivre les patients de votre service en faisant partie de leur Team de Soignants.</p>
                  <bouton href="invite-child-caregiver">Ajouter un enfant</bouton>
                  <bouton href="dashboard-caregiver">Aller au carnet de bord</bouton>
                </slide>
              </carousel>
            </div>
            <img src="@/assets/images/mascotte/mascotte-red.png" alt="Globulo Quest mascotte" title="Globulo Quest mascotte"/>
          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TitlePage from '@/components/TitlePage'
  import Bouton from '@/components/Bouton'
  import { Carousel, Slide } from 'vue-carousel'

  export default {
    components: { TitlePage, Bouton, Carousel, Slide },
    computed: {
    }
  }

</script>
